module.exports = __webpack_public_path__ + "img/CM-BS-24-CJDR-lifestyle.c5cd6801.jpg";